// extracted by mini-css-extract-plugin
module.exports = {"root":"DealHeaderActions__root___1CgYi","button":"DealHeaderActions__button___3rAPo"};